import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuth = useSelector((state) => state.authenticate.isAuth);
  return isAuth ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;